import { useEffect, RefObject } from 'react';

// Регулярное выражение для поиска слов в квадратных скобках
const HIGHLIGHT_REGEX = /\[([^\]]+)\]/g;
const HIGHLIGHT_NAME = 'placeholder-highlight';

function getCSSHighlights() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (CSS as any).highlights;
}

export const useHighlightPlaceholders = (elementRef: RefObject<HTMLDivElement | null>, text: string) => {
    useEffect(() => {
        if (!elementRef.current || !text) {
            return;
        }

        const cssHighlights = getCSSHighlights();

        // Проверяем поддержку CSS Custom Highlight API
        if (!cssHighlights) {
            console.warn('CSS Custom Highlight API не поддерживается в этом браузере');

            return;
        }

        const element = elementRef.current;
        const textNode = element.firstChild;

        if (!textNode || textNode.nodeType !== Node.TEXT_NODE) {
            return;
        }

        const ranges: Range[] = [];
        let match;

        while ((match = HIGHLIGHT_REGEX.exec(text)) !== null) {
            const range = new Range();
            range.setStart(textNode, match.index);
            range.setEnd(textNode, match.index + match[0].length);
            ranges.push(range);
        }

        const highlight = new Highlight(...ranges);

        cssHighlights.set(HIGHLIGHT_NAME, highlight);

        return () => {
            cssHighlights.delete(HIGHLIGHT_NAME);
        };
    }, [elementRef, text]);
};
